import { CashPickupBoxProps } from '@repo/types/cashPickupBoxProps.type';
import {
  IMG_CASH_PICKUP_FORCE_GUIDE_02,
  IMG_CASH_PICKUP_FORCE_GUIDE_03,
  IMG_CASH_PICKUP_FORCE_GUIDE_04,
  IMG_CASH_PICKUP_GUIDE_01,
  IMG_CASH_PICKUP_GUIDE_02,
  IMG_CASH_PICKUP_GUIDE_03,
  IMG_GUIDE_FORCE,
} from '@repo/assets';
import IMG_GUIDE_STEP_1 from '@/assets/airport/img_guide_step_1.png';
import IMG_GUIDE_STEP_2 from '@/assets/airport/img_guide_step_2.png';
import IMG_GUIDE_STEP_3 from '@/assets/airport/img_guide_step_3.png';

export const CASH_PICKUP_STORE_INTRO_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: (
      <>
        Enter Only Basic
        <br />
        Personal Information
      </>
    ),
    description:
      'Enter your personal information to pick up your refund in cash from Western Union.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Visit Customs',
    description:
      'Skip the kiosk and go straight to customs. Show your items and mobile Tax Refund receipt.',
    image: IMG_CASH_PICKUP_GUIDE_02,
  },
  {
    index: 3,
    title: (
      <>
        Receiving Your Refund
        <br />
        at Western Union
      </>
    ),
    description:
      'After you enter your information and it is verified by customs, we will send your refund within 21 days. You can then pick up the cash at Western Union.',
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];

export const CASH_PICKUP_FORCE_REFUND_CRUISE: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Enter Only Basic Personal Information',
    description:
      'Enter your personal information to pick up your refund in cash from Western Union.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Visit Customs',
    description:
      'Please visit the port, show your items, print your refund receipt, have it stamped, and submit it to Customs.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: 'Receiving Your Refund at Western Union',
    description:
      'After you enter your information and it is verified by customs, we will send your refund within at least 1~2 months. You can then pick up the cash at Western Union.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_03,
  },
];

export const CASH_PICKUP_FORCE_REFUND_PROCESS_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Enter Payment Information',
    description:
      'Save time at the airport with KTP Remittance Tax Refund. Enter your bank info within 3 months after purchase.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Print Refund Receipt & Visit Customs',
    description:
      'Please print the refund receipt sent to your email. Then, visit the Customs office, show your purchased items, and have your receipt stamped.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: 'Upload Stamped Refund Receipt',
    description:
      'Take a photo of the refund receipt stamped by Customs and upload it.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_04,
  },
  {
    index: 4,
    title: 'Available for Western Union refunds in the countries below',
    description:
      'After you enter your information and it is verified by customs, we will send your refund within at least 1~2 months. You can then pick up the cash at Western Union.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_03,
  },
];

export const FORCE_REFUND_CRUISE: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Enter Your Information',
    description: 'Enter your bank info within 3 months after purchase.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Print Refund Receipt & Visit Customs',
    description:
      'Please visit the port, show your items, print your refund receipt, have it stamped, and submit it to Customs.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: 'Refund Remittance',
    description:
      'Your refund will be transferred after Customs verification. Processing may take 1-2 months.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_03,
  },
];

export const FORCE_REFUND_CRUISE_KOR: CashPickupBoxProps[] = [
  {
    index: 1,
    title: '결제 정보 입력',
    description: '구매일로부터 3개월 이내에 은행 정보를 입력하세요',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: '환급 영수증 출력 및 세관 방문',
    description:
      '항구를 방문하여 구매한 물품을 보여주고, 환급 영수증을 출력한 후 세관에서 도장을 받아 제출하세요.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: '환급액 송금',
    description:
      '세관 확인 후 환급금이 송금됩니다. 송금까지 1-2달정도 소요됩니다.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_03,
  },
];

export const FORCE_REFUND_PROCESS_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Enter Payment Information',
    description:
      'Save time at the airport with KTP Remittance Tax Refund. Enter your bank info within 3 months after purchase.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Print Refund Receipt & Visit Customs',
    description:
      'Please print the refund receipt sent to your email. Then, visit the Customs office, show your purchased items, and have your receipt stamped.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: 'Upload Stamped Refund Receipt',
    description:
      'Take a photo of the refund receipt stamped by Customs and upload it.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_04,
  },
  {
    index: 4,
    title: 'Refund Remittance',
    description:
      'Refund will be sent within 21 business days after Customs check.',
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];

export const FORCE_REFUND_PROCESS_BOXES_KOR: CashPickupBoxProps[] = [
  {
    index: 1,
    title: '결제 정보 입력',
    description:
      'KTP 송금 택스리펀을 이용해 공항에서 시간을 절약하세요. 구매일로부터 3개월 이내에 은행 정보를 입력합니다.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: '환급 영수증 출력 및 세관 방문',
    description:
      '이메일로 받은 환급 영수증을 출력하세요. 그 후, 세관을 방문하여 구매한 물품을 보여주고 영수증에 도장을 받으세요.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: '도장 받은 환급 영수증 업로드',
    description:
      '세관에서 도장을 받은 환급 영수증을 사진으로 찍어 업로드하세요.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_04,
  },
  {
    index: 4,
    title: '환금액 송금',
    description: '세관 확인 후 21영업일 이내에 환급금이 송금됩니다.',
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];

export const REFUND_PROCESS_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Enter Payment Information',
    description:
      'Save time at the airport with KTP Remittance Tax Refund. Enter your bank info within 3 months after purchase.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Visit Customs',
    description:
      'Go straight to customs with your [KTP mobile Tax Refund Receipt] instead of waiting at a kiosk.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: 'Refund Remittance',
    description: `We'll send your refund amount to the refund\ninformation you provided. Refund will be\ncompleted about 21 business days.`,
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];

export const REFUND_PROCESS_BOXES_KOR: CashPickupBoxProps[] = [
  {
    index: 1,
    title: '결제 정보 입력',
    description:
      'KTP 송금 택스리펀을 이용해 공항에서 시간을 절약하세요. 구매일로부터 3개월 이내에 은행 정보를 입력합니다.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: '세관 방문',
    description:
      '키오스크에서 기다리지 말고 바로 세관으로 가세요.\n구매한 물건과 모바일 택스리펀 영수증을 보여주세요.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: '환급액 송금',
    description: `계좌 입력 및 세관 확인이 완료되면 환급액을 송금합니다.\n환급액 지급은 세관 확인 후 영업일 기준 21일 정도 소요\n됩니다.`,
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];

export const AIRPORT_FORCE_REFUND_PROCESS_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Visit Customs Kiosk',
    description:
      'Visit Airport and find the Customs Kiosk located on the land side. Check the lists of goods to refund.',
    image: IMG_GUIDE_STEP_1,
  },
  {
    index: 2,
    title: 'Get a customs stamp on receipts',
    description:
      'After printing the refund receipt, please get a customs stamp as shown below.',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: 'Get a refund',
    description:
      'Show the printed refund receipt at the Tax Refund Counter and receive your refund.',
    image: IMG_GUIDE_FORCE,
  },
];

export const AIRPORT_FORCE_REFUND_PROCESS_BOXES_KOR: CashPickupBoxProps[] = [
  {
    index: 1,
    title: '공항 일반지역에 설치된 세관 키오스크를 방문해 주세요',
    description:
      '공항에 방문하여 일반지역에 위치한 세관 키오스크를 찾으세요. 환급 대상 물품 목록을 확인하세요.',
    image: IMG_GUIDE_STEP_1,
  },
  {
    index: 2,
    title: '영수증에 세관의 확인(도장)을 받아주세요',
    description: '환급 영수증 출력 후, 아래 예시와 같이 세관 도장을 받으세요',
    image: IMG_CASH_PICKUP_FORCE_GUIDE_02,
  },
  {
    index: 3,
    title: '세관에서 환급액을 받으세요',
    description: '출력된 환급 영수증을 환급 창구에 제시하시고 환급을 받으세요.',
    image: IMG_GUIDE_FORCE,
  },
];

export const AIRPORT_REFUND_PROCESS_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Visit Customs Kiosk',
    description:
      'Visit Airport and find the Customs Kiosk located on the land side. Check the lists of goods to refund.',
    image: IMG_GUIDE_STEP_1,
  },
  {
    index: 2,
    title: 'Get customs validation',
    description:
      'Get customs validation through the customs officers.  Passport, Mobile Tax refund receipt, purchased goods must be presented.',
    image: IMG_GUIDE_STEP_2,
  },
  {
    index: 3,
    title: 'Get a refund',
    description:
      'Get refunds through the refund counter located on the air side.',
    image: IMG_GUIDE_STEP_3,
  },
];

export const AIRPORT_REFUND_PROCESS_BOXES_KOR: CashPickupBoxProps[] = [
  {
    index: 1,
    title: '환급 키오스크 이용',
    description:
      '일반구역에서 환급 키오스크를 찾아 환급 받을 항목을 확인해주세요.',
    image: IMG_GUIDE_STEP_1,
  },
  {
    index: 2,
    title: '세관 방문',
    description:
      '세관에 방문하여 구매한 물건과, 택스리펀 영수증을 직원에게 보여주세요.',
    image: IMG_GUIDE_STEP_2,
  },
  {
    index: 3,
    title: '환급받기',
    description: '면세구역에 있는 환급 창구에 방문하여 환급금을 수령하세요.',
    image: IMG_GUIDE_STEP_3,
  },
];
